import {Model} from '@vuex-orm/core'
import {Response} from "@vuex-orm/plugin-axios";

export default class BaseModel extends Model {

	static route;

	static transformDefault(response, key, default_return, code) {
		key = key ? key : (this.plural ? this.plural : this.entity);
		default_return = default_return ? default_return : [];
		code = code ? code : 200;
		if(response && response.status === code && response.data.data[key]) {
			let data = response.data.data[key];
			if(!Array.isArray(data)) {
				data = [data];
			}
			data = this.handleBeforeTransform(data);
			return data;
		} else {
			return default_return;
		}
	}

	static handleBeforeTransform(data) {
		return data;
	}

	static transformBrowse(model, response) {
		return model.transformDefault(response, model.plural);
	}

	static transformRetrieve(model, response) {
		return model.transformDefault(response, model.singular, null);
	}

	static transformCreate(model, response) {
		return model.transformDefault(response, model.singular, null);
	}

	static transformUpdate(model, response) {
		return model.transformDefault(response, model.singular, null);
	}

	static transformRemove(model, response) {
		return model.transformDefault(response, model.singular, null);
	}

	static configureApi() {
		return {
			actions: {
				fetch(params) {
					// if url has been provided then use that url
					const url = (params && params.url) ? params.url : '/' + this.model.route;

					const fetchResponse = this.get(url, {
						params: params,
						dataTransformer: (response) => {
							return this.model.transformBrowse(this.model, response);
						}
					});

					return fetchResponse;
				},
				retrieve(id, params) {
					return this.get('/'+this.model.route+'/'+id, {
						params: params,
						dataTransformer: (response) => {
							return this.model.transformRetrieve(this.model, response);
						}
					});
				},
				create(data) {
					return this.post('/'+this.model.route, data, {
						dataTransformer: (response) => {
							return this.model.transformCreate(this.model, response);
						}
					});
				},
				update(id, data) {
					if(data instanceof FormData && data.get('_method') === 'PUT') {
						return this.post('/'+this.model.route+'/'+id, data, {
							dataTransformer: (response) => {
								return this.model.transformUpdate(this.model, response);
							}
						});
					} else {
						return this.put('/'+this.model.route+'/'+id, data, {
							dataTransformer: (response) => {
								return this.model.transformUpdate(this.model, response);
							}
						});
					}
				},
				remove(id) {
					return this.delete('/'+this.model.route+'/'+id, {
						dataTransformer: (response) => {
							return this.model.transformRemove(this.model, response);
						}
					});
				},
			}
		};
	}

	static apiConfig = this.configureApi();

	static decodeHTMLEntities(text) {
		let textArea = document.createElement('textarea');
		textArea.innerHTML = text;
		return textArea.value;
	}

	static getResponseDataFromAPIResponse(response, key) {
		if(response instanceof Response) {
			console.log(response);
			if(response.response && response.response.data && response.response.data.data) {
				let temp = response.response.data.data;
				return (temp[key] ? temp[key] : temp);
			}
		}
		return null;
	}

}
